import initialState from '../../store/initialState';
import ModalEncuestaTipos from './ModalEncuestaTipos';

const ModalEncuestaReducer = (state = initialState.modales, action) => {
    switch (action.type) {
        case ModalEncuestaTipos.data.MOSTRAR_ENCUESTA:
            return ({
                ...state,
                showEncuesta: action.payload.showEncuesta
            });
        case ModalEncuestaTipos.data.LOAD_POSTS_REQUEST_ENCUESTA:
            return ({
                ...state,
                enEjecucionAPIEncuesta: action.payload.enEjecucionAPIEncuesta
            });
        case ModalEncuestaTipos.data.LOAD_POSTS_SUCCESS_ENCUESTA:
            return ({
                ...state,
                enEjecucionAPIEncuesta: false,
                responseApi: action.payload.responseEncuesta
            });
        case ModalEncuestaTipos.data.LOAD_POSTS_FAILURE_ENCUESTA:
            return ({
                ...state,
                enEjecucionAPIEncuesta: false,
                errorApi: action.payload.error
            });
            case ModalEncuestaTipos.data.GUARDAR_NOTA_SOCIO:
                return ({
                    ...state,
                    notaSocio: action.payload.notaSocio
                });
        default:
            return state;
    }
}

export default ModalEncuestaReducer;